<template>
  <div class="start-screen">
    <app-header title="DrinkUp" subtitle="Wähle deinen Spielmodus" />

    <div class="modes-container">
      <mode-card
        v-for="mode in gameModes"
        :key="mode.id"
        :mode="mode"
        :is-selected="selectedMode === mode.id"
        @select="selectMode(mode.id)"
      />
    </div>

    <app-button
      :is-pulsing="!!selectedMode"
      :is-disabled="!selectedMode"
      @click="startGame"
    >
      Spiel starten
    </app-button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AppHeader from "@/components/UI/AppHeader.vue";
import AppButton from "@/components/UI/AppButton.vue";
import ModeCard from "@/components/ModeCard.vue";

export default {
  name: "StartScreen",
  components: {
    AppHeader,
    AppButton,
    ModeCard,
  },
  computed: {
    ...mapGetters(["getGameModes"]),
    gameModes() {
      return this.getGameModes;
    },
    selectedMode() {
      return this.$store.state.selectedMode;
    },
  },
  methods: {
    ...mapActions(["selectMode"]),
    startGame() {
      if (this.selectedMode) {
        this.$router.push("/player-setup");
      }
    },
  },
};
</script>

<style scoped>
.start-screen {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.modes-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: var(--spacing-md);
  margin: var(--spacing-lg) 0;
}
</style>
